module.exports = __webpack_public_path__ + "4cdbbb7161e0316d0415040c44949294.png";